module.exports = __webpack_public_path__ + "img/cnu_gallery1.3ff35966.jpg";